import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

import { loginEmployee } from "../api/auth";
import styles from "./LoginPage.module.css";

export default function LoginPage({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async event => {
        event.preventDefault();

        if (!email.trim() || !password) {
            setError("Введите email и пароль");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const session = await loginEmployee(email, password);
            onLogin(session);
        } catch (loginError) {
            setError(loginError.message || "Не удалось войти");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className={styles.page}>
            <form className={styles.panel} onSubmit={handleSubmit}>
                <div>
                    <h1 className={styles.title}>Вход сотрудника</h1>
                    <p className={styles.subtitle}>Войдите с рабочим email и паролем.</p>
                </div>

                <label className={styles.label} htmlFor="employee-email">Email</label>
                <input
                    id="employee-email"
                    className={styles.input}
                    type="email"
                    autoComplete="username"
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    placeholder="employee@example.com"
                    autoFocus
                />

                <label className={styles.label} htmlFor="employee-password">Пароль</label>
                <div className={styles.passwordField}>
                    <input
                        id="employee-password"
                        className={styles.input}
                        type={showPassword ? "text" : "password"}
                        autoComplete="current-password"
                        value={password}
                        onChange={event => setPassword(event.target.value)}
                    />
                    <button
                        className={styles.passwordToggle}
                        type="button"
                        onClick={() => setShowPassword(value => !value)}
                        aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
                        title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                    >
                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                </div>

                {error && <p className={styles.error}>{error}</p>}

                <button className={styles.button} type="submit" disabled={loading}>
                    {loading ? "Вход..." : "Войти"}
                </button>
            </form>
        </main>
    );
}
